import React, { useState } from "react";
import ExportModal from "views/components/export/ExportModal";
import useView from "views/hooks/useView";
import { IconButton } from "components/common";
const ExportMessageWidgetActionComponent = ({ widget, disabled }) => {
  const [showExport, setShowExport] = useState(false);
  const view = useView();
  const showMessageExportModal = () => setShowExport(true);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      disabled,
      onClick: showMessageExportModal,
      name: "download",
      title: "Export all search results"
    }
  ), showExport && /* @__PURE__ */ React.createElement(ExportModal, { view, directExportWidgetId: widget.id, closeModal: () => setShowExport(false) }));
};
export default ExportMessageWidgetActionComponent;
